<template>
  <div>
    <div>
      <span>
        <i class="fas fa-credit-card"></i> &nbsp;
        <strong>Card provider</strong>
      </span>

      <br>
      <br>

      <label class="radio-container">
        VISA
        <input
          type="radio"
          id="provider"
          v-model="provider"
          :value="1000">
        <span class="checkmark"></span>
      </label>

      <label class="radio-container">
        MASTERCARD
        <input
          type="radio"
          id="provider"
          fieldlabel="Card provider"
          v-model="provider"
          :value="1001"
          v-taurus-validator="'required'"
        >
        <span class="checkmark"></span>
      </label>
      <div name="provider"></div>

      <br>

      <label for="name">Name on card</label>
      <input
        type="text"
        id="name"
        ref="name"
        fieldlabel="Name on card"
        class="form-control form-control-lg"
        v-model="name"
        v-taurus-validator="'required|min:5'"
      >
      <div name="name"></div>
      

      <label for="number">Card number</label>
      <input
        type="text"
        id="number"
        ref="number"
        fieldlabel="Card number"
        class="form-control form-control-lg"
        v-model="number"        
        v-taurus-validator="'required|numeric'"
      >
      <div name="number"></div>
      

      <label for="expiryDate">Expiry date</label>
      <input
        type="text"
        id="expiryDate"
        ref="expiryDate"
        fieldlabel="Expiry date"
        placeholder="MM/YYYY"
        class="form-control form-control-lg"
        v-model="expiryDate"
        v-taurus-validator="'required|monthYear'"
      >
      <div name="expiryDate"></div>
      

      <label for="code">CCV</label>
      <input
        type="text"
        id="code"
        ref="code"
        fieldlabel="CCV"
        class="form-control form-control-lg"
        v-model="code"
        v-taurus-validator="'required|numeric'"
      >
      <div name="code"></div>
      

      <label 
        v-if="!hideAddressCheck"
        class="check-container mt-2">
        Use address entered on claim form.
        <input type="checkbox" v-model="hideAddress">
        <span class="check-checkmark"></span>
      </label>

      <transition name="fade">
      <div v-show="!hideAddress">
        <label for="line1">Address</label>
        <input
          type="text"
          id="line1"
          ref="line1"
          fieldlabel="Address line 1"
          class="form-control form-control-lg"
          v-model="line1"
          v-taurus-validator="'required'"
        >
        <div name="line1"></div>
        

        <input
          type="text"
          id="line2"
          ref="line2"
          fieldlabel="Address line 2"
          class="form-control form-control-lg"
          v-model="line2"
        >

        <label for="town">Town</label>
        <input
          type="text"
          id="town"
          ref="town"
          fieldlabel="Town"
          class="form-control form-control-lg"
          v-model="town"
          v-taurus-validator="'required'"
        >
        <div name="town"></div>
        

        <label for="county">County</label>
        <input
          type="text"
          id="county"
          ref="county"
          fieldlabel="County"
          class="form-control form-control-lg"
          v-model="county"
          v-taurus-validator="'required'"
        >
        <div name="county"></div>
        

        <label for="postcode">Postcode</label>
        <input
          type="text"
          id="postcode"
          ref="postcode"
          fieldlabel="Postcode"
          class="form-control form-control-lg"
          v-model="postcode"
          v-taurus-validator="'required'"
        >
        <div name="postcode"></div>
        
      </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardDetails",
  props: {
    value: { required: true }
  },
  data() {
    return {

      // cardInfo: {
      //   name: '',
      //   number: '',
      //   expiryDate: '',
      //   code: '',
      //   line1: '',
      //   line2: '',
      //   town: '',
      //   county: '',
      //   postcode: '',

      //   provider: null,
      // },   

      name: null,
      number: null,
      expiryDate: null,
      code: null,
      line1: null,
      line2: null,
      town: null,
      county: null,
      postcode: null,

      provider: null,
      hideAddress: true,
      hideAddressCheck: false
    };
  },
  mounted() {
    if (this.value) {
      // this.cardInfo.name = this.value.name;
      // this.cardInfo.line1 = this.value.line1;
      // this.cardInfo.line2 = this.value.line2;
      // this.cardInfo.town = this.value.city;
      // this.cardInfo.county = this.value.county;
      // this.cardInfo.postcode = this.value.postcode;
      
      this.name = this.value.name;
      this.line1 = this.value.line1;
      this.line2 = this.value.line2;
      this.town = this.value.city;
      this.county = this.value.county;
      this.postcode = this.value.postcode;
    }

    this.watchAll(['name', 'number', 'expiryDate', 'code', 'line1', 'line2', 'town', 'county', 'postcode', 'provider'], this.onChange.bind(this));
    
  },
  methods: {
    watchAll: function(props, watcher) {
        var iterator = function(prop) {
            this.$watch(prop, watcher);
        };
        props.forEach(iterator, this);
    },
    onChange() {
      let { name, number, expiryDate, code, line1, line2, town, county, postcode, provider } = this

      this.$emit("input", { name, number, expiryDate, code, line1, line2, town, county, postcode, provider });
      let test = !this.$validator.some(e => e.valid === false);
      if (test == false) {
        let addrTest = this.addressValid()
        if (!addrTest) {
          this.hideAddress = false
          this.hideAddressCheck = true
        }
      }        
      this.$emit("isValid", test)
    },
    addressValid() {
      let fields = ['line1','town','county','postcode']
      let addrTest = !this.$validator.some(e => fields.includes(e.vmod) && e.valid === false)
      return addrTest
    }      
  },
  watch: {
    // this: {
    //   handler() {
    //     this.$emit("input", this.cardInfo);
    //     let test = !this.$validator.some(e => e.valid === false);        
    //     this.$emit("isValid", test)
    //   },
    //   deep: true
    // },
    // cardInfo: {
    //   handler() {
    //     this.$emit("input", this.cardInfo);
    //     let test = !this.$validator.some(e => e.valid === false);        
    //     this.$emit("isValid", test)
    //   },
    //   deep: true
    // }
  } 
};
</script>
